import type { PillConfig } from '#types/config/components/vf/pill'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    container: 'rounded bg-grey-80'
  }
} satisfies RecursivePartial<PillConfig>
